module.exports = __webpack_public_path__ + "static/media/locationNew.02b41182.svg";